export default {
  nfcDataSendToAnt: 'NFC数据发送至蚂蚁',
  sendTime: '发送时间',
  totalLines: '全部条数',
  sendPass: '发送成功',
  sendFail: '发送失败',
  uidSyncData: 'UID数据同步',
  syncDate: '同步时间',
  nfcDataCneterReceived: 'NFC 数据中心收到数量',
  wmsTaggingData: 'WMS 绑定数据',
  date: '绑定时间',
  plant: '仓库',
  nfcSentToAnt: '发送成功数量',
  failed: '失败数量',
  nfcDailyReport: 'NFC报告',
  vendor: '供应商'
}
